import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState, useCallback } from "react";
import { ProfileUrls } from "../../constants";
import NavatarLoader from "./NavatarLoader";
import UserAvatar from "./UserAvatar";
import CloseButton from "./CloseButton";
import AuthenticatedView from "./AuthenticatedView";
import UnauthenticatedView from "./UnauthenticatedView";
import Popover from "./Popover";
import FederateLoginModal from "../../components/FederateLoginModal";
export const NavatarBase = ({ locale, theme = "light", labels, onPopoverOpen, onElementClick, profilePageUrl = ProfileUrls.PROD, profile, login, logout, avatarUrl, isAuthenticated = false, displayGlobalDialog = true, }) => {
    const [state, setState] = useState({
        isActive: false,
        currentHref: "",
        isLoading: true,
        transitionStatus: "close",
        isAnimatingOut: false,
    });
    const containerRef = useRef(null);
    const { isActive, isLoading } = state;
    const getEncodedUrl = useCallback(() => {
        return encodeURIComponent(state.currentHref);
    }, [state.currentHref]);
    const togglePopover = useCallback(() => {
        setState((prev) => {
            if (prev.isActive) {
                setTimeout(() => {
                    setState((current) => ({
                        ...current,
                        isActive: false,
                        isAnimatingOut: false,
                    }));
                }, 100);
                return { ...prev, transitionStatus: "close", isAnimatingOut: true };
            }
            else {
                onPopoverOpen?.();
                return {
                    ...prev,
                    isActive: true,
                    transitionStatus: "open",
                    isAnimatingOut: false,
                };
            }
        });
    }, [onPopoverOpen]);
    const handleOnElementClick = useCallback((key) => {
        onElementClick?.(key);
    }, [onElementClick]);
    useEffect(() => {
        setState((prev) => ({ ...prev, currentHref: window.location.href }));
    }, [locale]);
    useEffect(() => {
        if (profile) {
            setState((prev) => ({ ...prev, isLoading: false }));
        }
    }, [profile]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isActive &&
                containerRef.current &&
                !containerRef.current.contains(event.target)) {
                setState((prev) => ({
                    ...prev,
                    transitionStatus: "close",
                    isAnimatingOut: true,
                }));
                setTimeout(() => {
                    setState((prev) => ({
                        ...prev,
                        isActive: false,
                        isAnimatingOut: false,
                    }));
                }, 100);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isActive]);
    useEffect(() => {
        const handleEscapeKey = (event) => {
            if (isActive && event.key === "Escape") {
                setState((prev) => ({
                    ...prev,
                    transitionStatus: "close",
                    isAnimatingOut: true,
                }));
                setTimeout(() => {
                    setState((prev) => ({
                        ...prev,
                        isActive: false,
                        isAnimatingOut: false,
                    }));
                }, 100);
            }
        };
        document.addEventListener("keydown", handleEscapeKey);
        return () => {
            document.removeEventListener("keydown", handleEscapeKey);
        };
    }, [isActive]);
    const isDark = theme === "dark";
    return (_jsxs("div", { ref: containerRef, className: `awsm-ik-navatar relative inline-block m-0 text-base ${isDark ? "dark" : ""}`, children: [_jsx("button", { onClick: togglePopover, className: `flex rounded-full items-center justify-center cursor-pointer transition-shadow duration-300
          hover:shadow-glow active:shadow-glow-active 
          focus:outline-none focus:ring-2 focus:ring-[#539fe5] focus:ring-offset-0 
          border-2 outline outline-2 outline-offset-[-1px] h-[40px] w-[40px] sm:h-[32px] sm:w-[32px] ${isDark
                    ? "bg-colorBaseGray850 border-white outline-colorBaseGray850 sm:bg-white sm:border-colorBaseGray850 sm:outline-white"
                    : "bg-white border-colorBaseGray850 outline-white sm:bg-colorBaseGray850 sm:border-white sm:outline-colorBaseGray850"} `, "aria-label": "navatar-icon", "data-testid": "navatar-icon", children: isAuthenticated ? (isLoading ? (_jsx(NavatarLoader, { theme: theme })) : (_jsx(UserAvatar, { src: avatarUrl, name: profile?.name, theme: theme, isAuthenticated: isAuthenticated, className: isDark
                        ? "text-white sm:text-colorBaseGray850"
                        : "text-colorBaseGray850 sm:text-white" }))) : (_jsx(UserAvatar, { src: "", name: "", theme: theme, isAuthenticated: isAuthenticated, className: isDark
                        ? "text-white sm:text-colorBaseGray850"
                        : "text-colorBaseGray850 sm:text-white" })) }), _jsxs(Popover, { isOpen: isActive || state.isAnimatingOut, theme: theme, transitionStatus: state.transitionStatus, children: [_jsx(CloseButton, { "data-testid": "navatar-close-button", onClose: () => {
                            setState((prev) => ({
                                ...prev,
                                transitionStatus: "close",
                                isAnimatingOut: true,
                            }));
                            setTimeout(() => {
                                setState((prev) => ({
                                    ...prev,
                                    isActive: false,
                                    isAnimatingOut: false,
                                }));
                            }, 100);
                        }, isDark: isDark }), isAuthenticated ? (_jsx(AuthenticatedView, { profile: profile, avatarUrl: avatarUrl, labels: labels, handleOnElementClick: handleOnElementClick, getEncodedUrl: getEncodedUrl, logout: logout, theme: theme, profilePageUrl: profilePageUrl })) : (_jsx(UnauthenticatedView, { labels: labels, handleOnElementClick: handleOnElementClick, login: login, getEncodedUrl: getEncodedUrl, profilePageUrl: profilePageUrl, theme: theme }))] }), displayGlobalDialog &&
                containerRef.current &&
                isAuthenticated &&
                !isLoading && (_jsx(FederateLoginModal, { profile: profile, labels: labels, handleOnElementClick: handleOnElementClick, getEncodedUrl: getEncodedUrl, login: login, theme: theme, container: containerRef.current, useContainer: false }))] }));
};
//# sourceMappingURL=NavatarBase.js.map